import React from 'react';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import * as HeroIconsOutline from '@heroicons/react/24/outline';
import * as HeroIconsSolid from '@heroicons/react/24/solid';

const EligibilityCard = ({ criteria, onEdit, onDelete }) => {
    // Dynamically get the icon component
    const OutlineIcon = HeroIconsOutline[criteria.icon_name];
    const SolidIcon = HeroIconsSolid[criteria.icon_name];
    const IconComponent = OutlineIcon || SolidIcon || HeroIconsOutline.StarIcon;

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-md transition-all group">
            <div className={`h-2 bg-gradient-to-r from-${criteria.gradient_from || 'blue-500'} to-${criteria.gradient_to || 'indigo-600'}`}></div>

            <div className="p-5">
                <div className="flex items-start justify-between mb-4">
                    <div className={`p-3 rounded-xl bg-gradient-to-br from-${criteria.gradient_from || 'blue-500'} to-${criteria.gradient_to || 'indigo-600'} text-white shadow-sm`}>
                        <IconComponent className="h-6 w-6" />
                    </div>
                    <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                            onClick={() => onEdit(criteria)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-primary-600 transition-colors"
                            title="Edit"
                        >
                            <PencilIcon className="h-5 w-5" />
                        </button>
                        <button
                            onClick={() => onDelete(criteria.id)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-red-600 transition-colors"
                            title="Delete"
                        >
                            <TrashIcon className="h-5 w-5" />
                        </button>
                    </div>
                </div>

                <div className="space-y-2">
                    <div className="flex items-center justify-between">
                        <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${criteria.is_active ? 'bg-green-50 text-green-600' : 'bg-slate-100 text-slate-500'}`}>
                            {criteria.is_active ? 'Active' : 'Inactive'}
                        </span>
                        <span className="text-[10px] font-bold text-slate-400">ORDER #{criteria.display_order}</span>
                    </div>
                    <p className="text-slate-700 font-medium leading-relaxed">
                        {criteria.criteria}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default EligibilityCard;
